import { Badge } from '@talentmesh/ui/components/badge';
import { TypographySmall } from '@talentmesh/ui/components/typography';
import { Brain, Drama, HeartHandshake, Wrench } from 'lucide-react';
import UIStrings from '@/Utils/UIStrings';

interface TestIncludedProps {
    hasPersonality?: boolean;
    hasAptitude?: boolean;
    hasSkills?: boolean;
    hasEmotionalIntelligence?: boolean;
}

function TestIncluded({ hasPersonality, hasAptitude, hasSkills, hasEmotionalIntelligence }: TestIncludedProps) {
    return (
        <div className="flex h-24 flex-1 basis-3/4 flex-col items-center justify-start gap-3">
            <TypographySmall className="text-muted-foreground text-center">{UIStrings.TestsIncluded}</TypographySmall>

            <div className="flex w-full flex-row flex-wrap content-center justify-center gap-1">
                {hasPersonality && (
                    <Badge className="gap-1">
                        <Drama className="size-3 shrink-0" aria-hidden />
                        {UIStrings.Personality}
                    </Badge>
                )}
                {hasAptitude && (
                    <Badge className="gap-1">
                        <Brain className="size-3 shrink-0" aria-hidden />
                        {UIStrings.Aptitude}
                    </Badge>
                )}
                {hasSkills && (
                    <Badge className="gap-1">
                        <Wrench className="size-3 shrink-0" aria-hidden />
                        {UIStrings.Skills}
                    </Badge>
                )}
                {hasEmotionalIntelligence && (
                    <Badge className="max-w-full gap-1 truncate">
                        <HeartHandshake className="size-3 shrink-0" aria-hidden />
                        {UIStrings.EmotionalIntelligence}
                    </Badge>
                )}
            </div>
        </div>
    );
}

export default TestIncluded;
